import * as React from 'react';

import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type DegreesV1 from 'bundles/naptimejs/resources/degrees.v1';
import type ProductSkuV1 from 'bundles/naptimejs/resources/productSkus.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type SubscriptionNextBillDetailsV1 from 'bundles/naptimejs/resources/subscriptionNextBillDetails.v1';
import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import type { OwnableProductByLegacyProductId } from 'bundles/payments-common/hooks/useFindOwnableProducts';
import type { SpecializationType } from 'bundles/payments-common/hooks/useGetSpecializationById';

export type PageDataContextType = {
  subscriptionId: string;
  subscription: SubscriptionsV1;
  s12n?: SpecializationType;
  mdp?: DegreesV1;
  productSku?: ProductSkuV1;
  ownableProduct: OwnableProductByLegacyProductId;
  subscriptionNextBillDetails?: SubscriptionNextBillDetailsV1;
  cart?: CartsV2;
  query: Record<string, string>;
  s12nProductName: string;
};

const PageDataContext = React.createContext<PageDataContextType | undefined>(undefined);

export default PageDataContext;
